import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '../../Button/Button';
import { COPY_ANIMATION_DURATION } from '../../../constants';
import { ReactComponent as IconContentCopy } from '../../../public/images/svg/icon_content_copy.svg';

const MetadataPanel = ({ metadata = {} }) => {
  const [hasCopiedContent, setCopiedContent] = useState({});
  const { title, description } = metadata;

  if (!title && !description) {
    return null;
  }

  const handleCopy = async (text, type, index) => {
    await navigator.clipboard
      .writeText(text)
      .then(
        () => {
          setCopiedContent((contentsToCopy) => ({ ...contentsToCopy, [`${type}-${index}`]: true }));
        },
        () => {
          console.error('Failed to copy');
        }
      )
      .finally(() => {
        setTimeout(() => {
          setCopiedContent((contentsToCopy) => ({
            ...contentsToCopy,
            [`${type}-${index}`]: false
          }));
        }, COPY_ANIMATION_DURATION);
      });
  };

  const createList = (items, type) => {
    return items.map((item, i) => (
      <div key={i} className="flex items-center mb-1 last:mb-0">
        <div className="grow mr-2">
          <strong>
            {type.charAt(0).toUpperCase() + type.slice(1)} {i + 1}:
          </strong>{' '}
          {item}
        </div>
        <div className="self-center">
          <Button
            onClick={() => handleCopy(item, type, i)}
            label={hasCopiedContent[`${type}-${i}`] ? 'Copied!' : 'Copy'}
            name={`copy-${type}`}
            dataTest={`copy-${type}-button-${i}`}
            type="button"
            className={[
              'transition ease-linear min-w-[90px] text-sm font-semibold text-grey-400 flex gap-2 justify-center items-center p-2 rounded',
              ...(hasCopiedContent[`${type}-${i}`] ? ['bg-green-400'] : ['bg-transparent'])
            ].join(' ')}
            icon={<IconContentCopy />}
          />
        </div>
      </div>
    ));
  };

  const titleList = createList(title ?? [], 'title');
  const descriptionList = createList(description ?? [], 'description');

  return (
    <div>
      <h3 className="text-xl font-normal leading-5 py-2.5 my-4">Meta Title & Description</h3>

      {title && (
        <div
          className="pb-4 mb-4 border-b text-sm text-grey-400"
          data-testid="metadata-panel-titles"
        >
          {titleList}
        </div>
      )}

      {description && (
        <div
          className="pb-4 mb-4 border-b text-sm text-grey-400"
          data-testid="metadata-panel-descriptions"
        >
          {descriptionList}
        </div>
      )}
    </div>
  );
};

MetadataPanel.propTypes = {
  metadata: PropTypes.shape({
    title: PropTypes.arrayOf(PropTypes.string),
    description: PropTypes.arrayOf(PropTypes.string)
  })
};

export default MetadataPanel;
